import { useEffect, useState } from "react";
import api from "../services/api";

const parseEtapes = (etapes) => {
  if (!etapes) return [];
  if (Array.isArray(etapes)) return etapes;
  try { return JSON.parse(etapes); } catch { return []; }
};

export default function TripsPage() {
  const [trips,       setTrips]       = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [filter,      setFilter]      = useState("all");
  const [selected,    setSelected]    = useState(null);
  const [passengers,  setPassengers]  = useState([]);
  const [loadingPass, setLoadingPass] = useState(false);

  const fetchTrips = async () => {
    setLoading(true);
    try {
      const res = await api.get("/admin/trips");
      setTrips(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      setTrips([]);
    }
    setLoading(false);
  };

  const fetchPassengers = async (tripId) => {
    setLoadingPass(true);
    try {
      const res = await api.get(`/api/trips/${tripId}/passengers`);
      setPassengers(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      setPassengers([]);
    }
    setLoadingPass(false);
  };

  useEffect(() => { fetchTrips(); }, []);

  const openTrip = async (trip) => {
    setSelected(trip);
    setPassengers([]);
    await fetchPassengers(trip.id);
  };

  const cancelTrip = async (id) => {
    if (!window.confirm("Annuler ce voyage ?")) return;
    try {
      await api.put(`/admin/trips/${id}/cancel`);
      fetchTrips();
      setSelected(null);
    } catch (err) {
      console.error(err);
    }
  };

  const filtered = filter === "all"
    ? trips
    : trips.filter(t => t.statut === filter);

  const formatDate = (d) => {
    if (!d) return "—";
    const date = new Date(d);
    return `${date.getDate().toString().padStart(2,"0")}/${(date.getMonth()+1).toString().padStart(2,"0")}/${date.getFullYear()} ${date.getHours().toString().padStart(2,"0")}:${date.getMinutes().toString().padStart(2,"0")}`;
  };

  const statutBadge = (s) => {
    const map = {
      published: { bg: "#E6F1FB", color: "#185FA5", label: "Publié"   },
      open:      { bg: "#FFF3CD", color: "#856404", label: "Complet"  },
      departed:  { bg: "#FAEEDA", color: "#854F0B", label: "En route" },
      completed: { bg: "#EAF3DE", color: "#3B6D11", label: "Terminé"  },
      cancelled: { bg: "#FCEBEB", color: "#A32D2D", label: "Annulé"   },
    };
    const s2 = map[s] ?? { bg: "#f0f0f0", color: "#888", label: s };
    return (
      <span style={{
        fontSize: 11, padding: "3px 10px", borderRadius: 20,
        fontWeight: 500, background: s2.bg, color: s2.color,
      }}>{s2.label}</span>
    );
  };

  const passStatutBadge = (s) => {
    const map = {
      confirmed:   { bg: "#E6F1FB", color: "#185FA5", label: "Confirmé" },
      picked_up:   { bg: "#EAF3DE", color: "#3B6D11", label: "Ramassé"  },
      dropped_off: { bg: "#EAF3DE", color: "#3B6D11", label: "Déposé"   },
      cancelled:   { bg: "#FCEBEB", color: "#A32D2D", label: "Annulé"   },
    };
    const s2 = map[s] ?? { bg: "#f0f0f0", color: "#888", label: s };
    return (
      <span style={{
        fontSize: 11, padding: "3px 8px", borderRadius: 20,
        fontWeight: 500, background: s2.bg, color: s2.color,
      }}>{s2.label}</span>
    );
  };

  const stats = [
    { label: "Total",    val: trips.length,                                      color: "#0B3C5D" },
    { label: "Publiés",  val: trips.filter(t => t.statut === "published").length, color: "#185FA5" },
    { label: "En route", val: trips.filter(t => t.statut === "departed").length,  color: "#854F0B" },
    { label: "Terminés", val: trips.filter(t => t.statut === "completed").length, color: "#3B6D11" },
  ];

  return (
    <div style={{ padding: "1.5rem 0" }}>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.5rem" }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 500, color: "#0B3C5D" }}>🚌 Voyages inter-régions</h1>
          <p style={{ fontSize: 14, color: "#888", marginTop: 4 }}>Gestion des voyages et passagers</p>
        </div>
        <button onClick={fetchTrips} style={{
          fontSize: 12, padding: "6px 14px", borderRadius: 20,
          cursor: "pointer", border: "0.5px solid #ccc", background: "#fff", color: "#888",
        }}>🔄 Actualiser</button>
      </div>

      {/* Stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 10, marginBottom: "1.25rem" }}>
        {stats.map(({ label, val, color }) => (
          <div key={label} style={{ background: "#fff", borderRadius: 10, padding: 14, border: "0.5px solid #e5e5e5" }}>
            <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: 22, fontWeight: 600, color }}>{val}</div>
          </div>
        ))}
      </div>

      {/* Filtres */}
      <div style={{ display: "flex", gap: 8, marginBottom: "1.25rem", flexWrap: "wrap" }}>
        {[["all","Tous"],["published","Publiés"],["open","Complets"],["departed","En route"],["completed","Terminés"],["cancelled","Annulés"]].map(([val, label]) => (
          <button key={val} onClick={() => setFilter(val)} style={{
            fontSize: 13, padding: "6px 16px", borderRadius: 20, cursor: "pointer",
            border: "0.5px solid #ccc",
            background: filter === val ? "#0B3C5D" : "#fff",
            color:      filter === val ? "#fff"     : "#888",
          }}>{label}</button>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: "#fff", border: "0.5px solid #e5e5e5", borderRadius: 12, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#0B3C5D" }}>
            <tr>
              {["ID","Trajet","Chauffeur","Date départ","Places","Prix/place","Statut","Action"].map(h => (
                <th key={h} style={{ padding: "12px 14px", textAlign: "left", fontSize: 12, fontWeight: 500, color: "#fff" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} style={{ padding: 30, textAlign: "center", color: "#aaa" }}>Chargement...</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={8} style={{ padding: 30, textAlign: "center", color: "#aaa" }}>Aucun voyage</td></tr>
            ) : filtered.map(t => {
              const etapes          = parseEtapes(t.etapes);
              const placesRestantes = parseInt(t.places_restantes ?? 4);
              return (
                <tr key={t.id} style={{ borderBottom: "0.5px solid #f0f0f0" }}>

                  <td style={{ padding: "12px 14px" }}>
                    <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 6, background: "#f0f0f0", color: "#888" }}>
                      #{t.id}
                    </span>
                  </td>

                  <td style={{ padding: "12px 14px" }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#0B3C5D" }}>
                      {t.depart_ville} → {t.arrivee_ville}
                    </div>
                    {etapes.length > 0 && (
                      <div style={{ fontSize: 11, color: "#aaa" }}>
                        via {etapes.join(" → ")}
                      </div>
                    )}
                  </td>

                  <td style={{ padding: "12px 14px", fontSize: 13, color: "#0B3C5D" }}>
                    {t.driver_name ?? "—"}
                    <div style={{ fontSize: 11, color: "#aaa" }}>{t.driver_phone}</div>
                  </td>

                  <td style={{ padding: "12px 14px", fontSize: 13, color: "#888" }}>
                    {formatDate(t.date_depart)}
                  </td>

                  <td style={{ padding: "12px 14px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      {[1,2,3,4].map(seat => {
                        const taken = (4 - placesRestantes) >= seat;
                        return (
                          <div key={seat} style={{
                            width: 16, height: 16, borderRadius: 3,
                            background: taken ? "#0B3C5D" : "#f0f0f0",
                            border: `1px solid ${taken ? "#0B3C5D" : "#ddd"}`,
                            fontSize: 8, color: taken ? "#fff" : "#ccc",
                            display: "flex", alignItems: "center", justifyContent: "center",
                          }}>{seat}</div>
                        );
                      })}
                      <span style={{ fontSize: 11, color: "#888", marginLeft: 4 }}>
                        {placesRestantes}/4
                      </span>
                    </div>
                  </td>

                  <td style={{ padding: "12px 14px", fontWeight: 500, color: "#0B3C5D" }}>
                    {Number(t.prix_par_place).toLocaleString("fr-FR")} CFA
                  </td>

                  <td style={{ padding: "12px 14px" }}>
                    {statutBadge(t.statut)}
                  </td>

                  <td style={{ padding: "12px 14px" }}>
                    <button onClick={() => openTrip(t)} style={{
                      fontSize: 12, padding: "5px 12px", borderRadius: 6,
                      border: "0.5px solid #B5D4F4", background: "#E6F1FB",
                      color: "#185FA5", cursor: "pointer",
                    }}>👁 Voir</button>
                  </td>

                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Modal détail voyage */}
      {selected && (
        <div onClick={() => setSelected(null)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
          display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#fff", borderRadius: 16, padding: 24,
            width: 640, maxHeight: "90vh", overflowY: "auto",
          }}>

            {/* Modal header */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <div>
                <h2 style={{ fontSize: 18, fontWeight: 700, color: "#0B3C5D" }}>
                  {selected.depart_ville} → {selected.arrivee_ville}
                </h2>
                <p style={{ fontSize: 13, color: "#888", marginTop: 4 }}>
                  {formatDate(selected.date_depart)} • {selected.driver_name}
                </p>
              </div>
              <button onClick={() => setSelected(null)} style={{
                background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "#888",
              }}>✕</button>
            </div>

            {/* Infos voyage */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
              {[
                ["💰 Prix/place", `${Number(selected.prix_par_place).toLocaleString("fr-FR")} CFA`],
                ["💺 Places",     `${parseInt(selected.places_restantes ?? 4)}/4 restantes`],
                ["📊 Statut",     selected.statut],
              ].map(([label, val]) => (
                <div key={label} style={{ background: "#f7f7f7", borderRadius: 10, padding: 12 }}>
                  <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>{label}</div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: "#0B3C5D" }}>{val}</div>
                </div>
              ))}
            </div>

            {/* Étapes */}
            {parseEtapes(selected.etapes).length > 0 && (
              <div style={{ marginBottom: 16, padding: 12, background: "#f7f7f7", borderRadius: 10 }}>
                <div style={{ fontSize: 12, color: "#888", marginBottom: 6 }}>Itinéraire</div>
                <div style={{ fontSize: 13, color: "#0B3C5D" }}>
                  {selected.depart_ville} → {parseEtapes(selected.etapes).join(" → ")} → {selected.arrivee_ville}
                </div>
              </div>
            )}

            {/* Chauffeur */}
            <div style={{ marginBottom: 16, padding: 12, background: "#f7f7f7", borderRadius: 10 }}>
              <div style={{ fontSize: 12, color: "#888", marginBottom: 6 }}>Chauffeur</div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: "#0B3C5D" }}>{selected.driver_name}</span>
                <span style={{ fontSize: 13, color: "#888" }}>📞 {selected.driver_phone}</span>
              </div>
            </div>

            {/* Passagers */}
            <div style={{ marginBottom: 16 }}>
              <p style={{ fontSize: 14, fontWeight: 600, color: "#0B3C5D", marginBottom: 12 }}>
                👥 Passagers ({passengers.length})
              </p>

              {loadingPass ? (
                <p style={{ color: "#aaa", fontSize: 13 }}>Chargement...</p>
              ) : passengers.length === 0 ? (
                <div style={{ padding: 20, textAlign: "center", color: "#aaa", background: "#f7f7f7", borderRadius: 10 }}>
                  Aucun passager réservé
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {passengers.map((p, i) => (
                    <div key={p.booking_id ?? i} style={{
                      padding: "12px 14px", borderRadius: 10,
                      border: "0.5px solid #e5e5e5",
                      background: p.no_show ? "#FCEBEB" : p.statut === "picked_up" ? "#EAF3DE" : "#fff",
                      display: "flex", alignItems: "center", gap: 12,
                    }}>

                      {/* Numéro ordre */}
                      <div style={{
                        width: 32, height: 32, borderRadius: 8,
                        background: "#0B3C5D", color: "#fff",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: 14, fontWeight: 700, flexShrink: 0,
                      }}>
                        {i + 1}
                      </div>

                      {/* Infos */}
                      <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 2 }}>
                          <span style={{ fontSize: 14, fontWeight: 500, color: "#0B3C5D" }}>
                            {p.passager_nom ?? "Passager"}
                          </span>
                          {p.is_driver_booking && (
                            <span style={{ fontSize: 10, padding: "2px 6px", borderRadius: 4, background: "#FAEEDA", color: "#854F0B" }}>
                              Ami/Famille
                            </span>
                          )}
                          {p.no_show && (
                            <span style={{ fontSize: 10, padding: "2px 6px", borderRadius: 4, background: "#FCEBEB", color: "#A32D2D" }}>
                              No-show
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: 12, color: "#888" }}>
                          📞 {p.telephone ?? "—"}
                        </div>
                        {p.pickup_description && (
                          <div style={{ fontSize: 12, color: "#888" }}>
                            📍 {p.pickup_description}
                          </div>
                        )}
                        {p.pickup_lat && (
                          <div style={{ fontSize: 11, color: "#aaa" }}>
                            🗺 {Number(p.pickup_lat).toFixed(4)}, {Number(p.pickup_lng).toFixed(4)}
                          </div>
                        )}
                      </div>

                      {/* Statut + commission */}
                      <div style={{ textAlign: "right" }}>
                        {passStatutBadge(p.statut)}
                        {!p.is_driver_booking && (
                          <div style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>
                            Commission : {p.commission} CFA
                          </div>
                        )}
                        {p.gps_distance_at_pickup && (
                          <div style={{ fontSize: 10, color: "#aaa" }}>
                            GPS validé : {p.gps_distance_at_pickup}m
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Actions admin */}
            {["published", "open", "departed"].includes(selected.statut) && (
              <button onClick={() => cancelTrip(selected.id)} style={{
                width: "100%", padding: "10px", borderRadius: 8, border: "none",
                background: "#FCEBEB", color: "#A32D2D", fontSize: 13,
                cursor: "pointer", fontWeight: 500,
              }}>
                ✖ Annuler le voyage
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}